export enum ValidationCheck {
  EmptyFile = 'emptyFile',
  DistanceToSiteMeters = 'distanceToSiteMeters',
  ScanToPanoMissupload = 'scanToPanoMissupload',
  PanoToScanMissupload = 'panoToScanMissupload',
  GimbalAngleDegrees = 'gimbalAngleDegrees',
  DroneModelOk = 'droneModelOk',
  BlurScore = 'blurScore',
  PhotoAgeHours = 'photoAgeHours',
  PhotoFromFuture = 'photoFromFuture',
}
